import React from 'react';
import {
  PageListingRow,
  PageListingItem,
  PageListingDescriptionItem,
} from 'components/Listing/PageListing';
import Table from 'components/Table/Table';
import Format from 'helpers/format';
import Text, { TextLink } from '@lightspeed/cirrus-text';

import get from 'lodash/get';

export default class PaymentInfoReportRefunds extends React.Component {
  render() {
    const { refunds, dateTimeFormat, isSalePayment } = this.props;

    const rowData = refunds.map(refund => {
      const dateTime = Format.formatDateTime(refund.createdAt, dateTimeFormat, true);
      const date = <Text bodySmall>{dateTime.substr(0, dateTime.indexOf(' '))}</Text>;
      const time = <Text bodySmall>{dateTime.substr(dateTime.indexOf(' ') + 1)}</Text>;
      const saleIdLink =
        get(refund, 'saleID') !== '0' ? (
          <Text bodySmall bold className="retail-table__truncatd-item">
            <TextLink
              href={`/?form_name=view&name=transaction.views.transaction&id=${refund.saleID}`}
            >
              {refund.saleID}
            </TextLink>
          </Text>
        ) : (
          <Text bodySmall>N/A</Text>
        );

      let paymentLink;
      if (isSalePayment) {
        const salePaymentID = get(refund, 'SalePayment.salePaymentID', null);
        paymentLink = (
          <Text bodySmall bold className="retail-table__truncated-item">
            <TextLink href={`/reports/payment/retail/${salePaymentID}`}>{salePaymentID}</TextLink>
          </Text>
        );
      } else {
        const paymentID = get(refund, 'paymentID', null);
        paymentLink = (
          <Text bodySmall bold className="retail-table__truncated-item">
            <TextLink href={`/reports/payment/${paymentID}`}>{paymentID}</TextLink>
          </Text>
        );
      }

      return [
        paymentLink,
        saleIdLink,
        <Text bodySmall>{refund.operationType}</Text>,
        date,
        time,
        <Text bodySmall>{Format.formatPrice(refund.totalAmount)}</Text>,
      ];
    });

    return (
      <PageListingRow>
        <PageListingDescriptionItem
          mainText="Related Transactions"
          secondaryText="Other payment records related to this transaction."
        />
        <PageListingItem>
          <Table
            headings={['Payment ID', 'Sale ID', 'Type', 'Date', 'Time', 'Amount']}
            rows={rowData}
          />
        </PageListingItem>
      </PageListingRow>
    );
  }
}
